import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'

import ModalWrapper from 'components/ModalWrapper'
import { Selector } from 'components/SmartChatView/Fields'
import ActionsView from '../ActionsView'

const ActionModalUI = ({
  mode,
  isOpen,
  toggle,
  legend,
  modalActionRef,
  actionDetail,
  processDetail,
  dataWay,
  actionTypeOptions,
  actionTypeValue,
  onChangeActionTypeValue,
  actionsOptions,
  actionValue,
  onChangeActionValue,
  handleSaveAction,
  actionsErrors,
  modalLoading,
  modalError
}) => (
  <ModalWrapper
    id='smartChatActionsModal'
    isOpen={isOpen}
    toggle={toggle}
    header={I18n.t(`chatbot_action_header_${mode}`)}
    legend={legend}
    eventBtn={handleSaveAction}
    eventBtnTxt={I18n.t('dashboard_save')}
    cancelBtn={toggle}
    cancelBtnTxt={I18n.t('dashboard_cancel')}
    isSubmitting={modalLoading}
    error={modalError && I18n.t(modalError.message)}
    contentClassName='smartchat-modal'
    body={
      <div className='modal-content modal-content--spaced'>
        {modalActionRef.type !== 'bot' && processDetail.processType === 'transactional' && (
          <Selector
            isRequired
            label={I18n.t('dashboard_type')}
            placeholder={I18n.t('smartchat_actions_selectType')}
            options={actionTypeOptions}
            value={actionTypeValue}
            onChange={onChangeActionTypeValue}
            isDisabled={actionTypeValue?.value ? true : false}
            error={actionsErrors.actionType}
          />
        )}

        {(actionTypeValue?.value || modalActionRef.type === 'bot') && (
          <Selector
            isRequired
            label={I18n.t('dashboard_action')}
            placeholder={I18n.t('dashboard_choose-action')}
            options={actionsOptions}
            value={actionValue}
            onChange={onChangeActionValue}
            isDisabled={actionValue?.value ? true : false}
            error={actionsErrors.action}
          />
        )}

        {actionValue?.value && (
          <ActionsView
            renderType='action'
            actionType={actionValue.value}
            previewActionDetail={actionDetail}
            currentValue={actionDetail.eventData || actionDetail.actionProperties}
            dataWay={dataWay}
          />
        )}
      </div>
    }
  />
)

export default ActionModalUI
